import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";

import type { MenuSections } from "../../types/menuSectionTypes";
import type { UseOptions } from "../hookTypes"

const GET_MENU_ITEMS = gql`
  query menuSections($menuId: ID!) {
    menuSections(menuId: $menuId) {
      id
      name
      position
    }
  }
`;

const useMenuSections = (id: string | number | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<MenuSections>(GET_MENU_ITEMS, {
    variables: { menuId: String(id) },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });


  if (refetchOnMount && !loading) {
    refetch();
  }

  const menuSections = data?.menuSections;

  const refetchMenuSections = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    menuSections,
    loading,
    error: error as Error | null | undefined,
    refetchMenuSections,
  };
}

export default useMenuSections
